import React, { useEffect, useRef } from "react";

import { Flex } from "../hex-components";
import { LoadingView } from "../views/LoadingView";

import { Routes, useQueryParams, useUrlFragment } from "./routes";

export const MagicAuthCallbackRoute: React.ComponentType = React.memo(
  function MagicAuthCallbackRoute() {
    const fragment = useUrlFragment();
    const queryParams = useQueryParams();

    const formRef = useRef<HTMLFormElement>(null);
    useEffect(() => {
      formRef.current?.submit();
    }, []);

    return (
      <Flex>
        {/* We use a hidden form here so we can trigger a post request that follows redirection */}
        <form
          ref={formRef}
          action={Routes.MAGIC_AUTH_CALLBACK.getUrl({
            queryParams: {
              ...Object.fromEntries(queryParams.entries()),
            },
          })}
          method="post"
        >
          <input name="token" type="hidden" value={fragment.token} />
        </form>
        <LoadingView />
      </Flex>
    );
  },
);
